import React, { useState } from "react";
import WalletConnect from "./components/WalletConnect";
import Minting from "./components/Minting";
import { ethers } from "ethers";

window.ethers = ethers; // ✅ Make ethers globally accessible in the console

const App = () => {
  const [signer, setSigner] = useState(null);

  return (
    <div>
      <h1>NFT Minting DApp</h1>
      <WalletConnect setSigner={setSigner} />
      <Minting signer={signer} />
    </div>
  );
};

export default App;
